export default function Welcome(props: any) {

return (<div className="App">
        <header className="App-header">
            <div className="logo">Deine digitale Rechnung</div>
        </header>
    </div>);
}